import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectDoctorState } from '../../../../store/app.states';
import { DoctorService } from '../../../../services/doctor.service';
import { MatDialog } from '@angular/material/dialog';
import { ExcelService } from '../../../../services/excel.service';
import { DatePipe } from '@angular/common';
import * as internal from 'assert';

@Component({
  selector: 'app-analyses-data',
  templateUrl: './analyses-data.component.html',
  styleUrls: ['./analyses-data.component.css']
})
export class AnalysesDataComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  patientSSN: string;
  // subscribe and unsubscribe
  subscription: Subscription;
  subscription1: Subscription;
  subscription2: Subscription;
  // per la tabella
  dataSource;
  dataSourceArray1 = [];
  dataSourceArray2 = [];
  dataSourceArray = [];
  totalSize = 0;
  isDataAvailable = false;
  headTotalElements = ['name', 'surname', 'Sex',
    "SSN", 'birthdate', 'Age', 'DateOfDiagnosis', 'AgeAtDiagnosis', 'Familiarity', 'Group', 'Pathology', 'PathologyDuration', 'Weight', 'Height', 'Interventi', 'NumResezioni',
    'LocatColonCD', 'LocatIleumCD', 'LocatUpperGI', 'LocalizzazioneUC', 'InfiammatorioCD', 'MalattiaPerianaleCD', 'PenetranteCD', 'StenosanteCD', 'Stomia',
    'TherapyTOPICA', 'TherapyIMM', 'TherapyGCSOS', 'TherapyFiveASAOS', 'TherapyBIO', 'AttiveEIMS', 'StoricheEIMS', "Num SCCAI", "data SCCAI", "SCCAI basale", "data SCCAI +3", "SCCAI +3", "data SCCAI +6", "SCCAI +6", "data SCCAI +9", "SCCAI +9", "data SCCAI +12", "SCCAI +12", "Num CLINICAL-SCCAI", "data CLINICAL-SCCAI", "CLINICAL-SCCAI basale", "data CLINICAL-SCCAI +3", "CLINICAL-SCCAI +3", "data CLINICAL-SCCAI +6", "CLINICAL-SCCAI +6", "data CLINICAL-SCCAI +9", "CLINICAL-SCCAI +9", "data CLINICAL-SCCAI +12", "CLINICAL-SCCAI +12",
    "Num HBI", "data HBI", "HBI basale", "data HBI +3", "HBI +3", "data HBI +6", "HBI +6", "data HBI +9",
    "HBI +9", "data HBI +12", "HBI +12", "Num CLINICAL-HBI", "data CLINICAL-HBI", "CLINICAL-HBI basale",
    "data CLINICAL-HBI +3", "CLINICAL-HBI +3", "data CLINICAL-HBI +6", "CLINICAL-HBI +6",
    "data CLINICAL-HBI +9", "CLINICAL-HBI +9", "data CLINICAL-HBI +12", "CLINICAL-HBI +12",
    "Num PRISM", "data PRISM", "PRISM basale", "data PRISM +3", "PRISM +3", "data PRISM +6",
    "PRISM +6", "data PRISM +9", "PRISM +9", "data PRISM +12", "PRISM +12", "Num CLINICAL-PRISM",
    "data CLINICAL-PRISM", "CLINICAL-PRISM basale", "data CLINICAL-PRISM +3", "CLINICAL-PRISM +3",
    "data CLINICAL-PRISM +6", "CLINICAL-PRISM +6", "data CLINICAL-PRISM +9", "CLINICAL-PRISM +9",
    "data CLINICAL-PRISM +12", "CLINICAL-PRISM +12", "Num MIAHCD", "data MIAHCD", "MIAHCD basale", "data MIAHCD +3", "MIAHCD +3", "data MIAHCD +6", "MIAHCD +6", "data MIAHCD +9",
    "MIAHCD +9", "data MIAHCD +12", "MIAHCD +12", "Num MIAHUC", "data MIAHUC", "MIAHUC basale", "data MIAHUC +3", "MIAHUC +3", "data MIAHUC +6", "MIAHUC +6", "data MIAHUC +9",
    "MIAHUC +9", "data MIAHUC +12", "MIAHUC +12", "Num IBD-Disk", "data IBD-Disk", "IBD-Disk basale", "data IBD-Disk +3", "IBD-Disk +3", "data IBD-Disk +6", "IBD-Disk +6", "data IBD-Disk +9",
    "IBD-Disk +9", "data IBD-Disk +12", "IBD-Disk +12", "Num MMAS8", "data MMAS8", "MMAS8 basale", "data MMAS8 +3", "MMAS8 +3", "data MMAS8 +6", "MMAS8 +6", "data MMAS8 +9",
    "MMAS8 +9", "data MMAS8 +12", "MMAS8 +12", "Num PHQ9", "data PHQ9", "PHQ9 basale", "data PHQ9 +3", "PHQ9 +3", "data PHQ9 +6", "PHQ9 +6", "data PHQ9 +9",
    "PHQ9 +9", "data PHQ9 +12", "PHQ9 +12", "Num IBDQ", "data IBDQ", "IBDQ basale", "data IBDQ +3", "IBDQ +3", "data IBDQ +6", "IBDQ +6", "data IBDQ +9",
    "IBDQ +9", "data IBDQ +12", "IBDQ +12", "Num EQ5D5L", "data EQ5D5L", "EQ5D5L basale", "data EQ5D5L +6", "EQ5D5L +6", "data EQ5D5L +12", "EQ5D5L +12", "Q.1 Gradimento", "Q.2 Gradimento", "Q.3 Gradimento", "Q.4 Gradimento", "Q.5 Gradimento", "Q.6 Gradimento", "Q.7 Gradimento", "Q.8 Gradimento", "Q.9 Gradimento"];


  // per il paginator
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];


  @ViewChild(MatPaginator, { static: false }) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private router: Router,
    private store: Store<AppState>,
    private doctorService: DoctorService,
    public dialog: MatDialog,
    private excelService: ExcelService,
    public datepipe: DatePipe) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }

  ngOnInit(): void {
    this.subscription = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.getAllPatientsData();
    })
  }

  ngOnDestroy() {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription.unsubscribe();



  }


  getDataAnalyses() {
    this.subscription1 = this.doctorService.getDataAnalyses().subscribe(data => {
      const elements = Object.keys(data).length;

      for (let element = 0; element < elements; element++) {
        // per prima cosa creo una riga inizializzata vuota per ogni campo (con dei '-')     
        let array = new Map<string, string>();
        for (let k = 0; k < this.headTotalElements.length; k++) {
          for (let kk = 0; kk < Object.keys(data[element]).length; kk++) {

            if (Object.keys(data[element])[kk] === this.headTotalElements[k]) {
              array[this.headTotalElements[k]] = Object.values(data[element])[kk];
            }


          }

          for (let kk = 0; kk < Object.keys(data[element]).length; kk++) {

            if (Object.keys(this.dataSourceArray2[element])[kk] === this.headTotalElements[k]) {
              array[this.headTotalElements[k]] = Object.values(this.dataSourceArray2[element])[kk];
            }

          }



        }
        // this.dataSource.push(array);
        this.dataSourceArray.push(array);
        // console.log(array);    
      }

      this.getPagination(this.dataSourceArray);

      this.isDataAvailable = true;

    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    })


      ;
  }




  getAllPatientsData() {
    this.subscription2 = this.doctorService.getAllPatientsData().subscribe(data => {
      const elements = Object.keys(data).length;

      for (let element = 0; element < elements; element++) {
        // per prima cosa creo una riga inizializzata vuota per ogni campo 

        let array = new Map<string, string>();
        for (let k = 0; k < this.headTotalElements.length; k++) {
          for (let kk = 0; kk < Object.keys(data[element]).length; kk++) {

            if (Object.keys(data[element])[kk] === this.headTotalElements[k]) {
              array[this.headTotalElements[k]] = Object.values(data[element])[kk];
            }

          }

        }
        // this.dataSource.push(array);
        this.dataSourceArray2.push(array);
        // console.log(array);
        //this.concatData();
      }

      this.getDataAnalyses();



    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    })


      ;
  }







  getPagination(data) {
    this.dataSource = new MatTableDataSource<any>();
    this.tasks = data;
    this.totalSize = this.tasks.length;
    this.currentPage = 0;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }

  exportAsXLSX(): void {
    let dateTime = new Date();
    let latest_date = this.datepipe.transform(dateTime, 'yyyy-MM-dd');
    this.excelService.exportAsExcelFile(this.dataSourceArray, this.headTotalElements, 'DataAnalyses_Score' + latest_date.toString());
  }










}






